import { render } from "./LoadingBlockUIComponent.vue?vue&type=template&id=01cb4737"
import script from "./LoadingBlockUIComponent.vue?vue&type=script&lang=js"
export * from "./LoadingBlockUIComponent.vue?vue&type=script&lang=js"

import "./LoadingBlockUIComponent.vue?vue&type=style&index=0&id=01cb4737&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__